/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Children } from 'react';
import { findDOMNode } from 'react-dom';

type Props = {
  onClickAway: () => void;
  closeOnClick?: boolean;
  children: React.ReactNode;
};

class ClickAway extends Component<Props> {
  _mounted = false;
  _node: any;
  _timer: TimeoutID;

  componentDidMount() {
    this._mounted = true;
    let body = document.body;
    if (body) {
      // Attaching listener right away after mount will execute
      // onClickAway on first click.
      this._timer = setTimeout(() => {
        body.addEventListener('mouseup', this._handleClickAway);
      }, 0);
    }
    this._node = findDOMNode(this);
  }

  componentWillUnmount() {
    this._mounted = false;
    let body = document.body;
    if (body) {
      body.removeEventListener('mouseup', this._handleClickAway);
    }
    if (this._timer) {
      clearTimeout(this._timer);
    }
  }

  render() {
    return Children.only(this.props.children);
  }

  _handleClickAway = (event: MouseEvent) => {
    // Ignore events that have been `event.preventDefault()` marked.
    if (event.defaultPrevented) {
      return;
    }

    // IE11 support, which trigger the handleClickAway even after the unbind
    if (!this._mounted) {
      return;
    }

    // The child might render null.
    if (!this._node) {
      return;
    }

    // // TODO: Make sure the type of e.target is ?Node
    if (!this.props.closeOnClick && this._node.contains(event.target)) {
      return;
    }

    setTimeout(() => {
      // Delay this so that the onClick event has time to fire.
      if (this._mounted) {
        this.props.onClickAway();
      }
    }, 10);
  };
}

export default ClickAway;
